import { useCallback } from 'react'
import {
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	clientApi
} from 'interface/endpoints'
import {
	ClientResult,
	ClientResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListClient = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<ClientResultList>(
        apiAccess,
				clientApi('/list', { t }),
        cancelToken
      )
    },
		[]
	)
)

export const useGetClient = (
	clientId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!clientId) return null
      return ApiGetWithToken<ClientResult>(
        apiAccess,
				clientApi(`/${clientId}`, { t }),
        cancelToken
      )
    },
		[clientId]
	)
)
